import { render, staticRenderFns } from "./LayoutPanel.vue?vue&type=template&id=a7900048"
import script from "./LayoutPanel.vue?vue&type=script&lang=js"
export * from "./LayoutPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports